var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:{ CurrencyValue_voided: !_vm.billable}},[_vm._v(_vm._s(_vm.formattedValue))]),(!_vm.billable)?_c('span',{staticClass:"CurrencyVoided"},[_vm._v(_vm._s(_vm.$t('VOIDED')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }